// import '@/scss/style.scss'
import numberRollup from './lib/rollup.js'

if(document.querySelectorAll('.number-rollup').length) {
    numberRollup({
        formatNumber: (s) => s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    });
}